import React, { useEffect, useRef } from "react";
import permisDeConduire from "assets/puzzles/iserba/roadSafety/permis_de_conduire.svg";

const IserbaScorePermis = ({ quizResults }) => {
	const scoreRef = useRef(null);

	useEffect(() => {
		scoreRef.current.classList.remove("score-up");
		void scoreRef.current.offsetWidth;
		scoreRef.current.classList.add("score-up");
	}, [quizResults.score]);

	return (
		<div
			className="relative w-[50px] h-[70px] bg-no-repeat bg-cover bg-center flex items-end justify-center font-bold"
			style={{
				backgroundImage: `url(${permisDeConduire})`,
			}}
		>
			<div ref={scoreRef} className="absolute bottom-2 text-black">
				{quizResults.score}
			</div>
		</div>
	);
};

export default IserbaScorePermis;
